import styled from "styled-components";

export const RegulatoryDataDefaultBox = styled.div`
  display: flex;
  align-items: center;

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    flex-direction: column;
    width: 100%;
    padding: 0.5rem 1.5rem;
  }

  .cgp-dk & {
    flex-direction: row-reverse;
  }
  
`;